export { default as Img200 } from './processed/200/Sally4Ever-S1.jpg';
export { default as Img400 } from './processed/400/Sally4Ever-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Sally4Ever-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Sally4Ever-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Sally4Ever-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      232,
      30,
      38
    ],
    "_population": 165,
    "_hsl": [
      0.9933993399339934,
      0.8145161290322579,
      0.5137254901960784
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      128,
      120
    ],
    "_population": 2,
    "_hsl": [
      0.011494252873563216,
      0.7532467532467534,
      0.6980392156862745
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      149,
      47,
      60
    ],
    "_population": 5,
    "_hsl": [
      0.9787581699346406,
      0.5204081632653061,
      0.3843137254901961
    ]
  },
  "Muted": {
    "_rgb": [
      166,
      142,
      87
    ],
    "_population": 66,
    "_hsl": [
      0.11603375527426162,
      0.31225296442687744,
      0.49607843137254903
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      199,
      207
    ],
    "_population": 86,
    "_hsl": [
      0.5493827160493827,
      0.21951219512195116,
      0.7588235294117647
    ]
  },
  "DarkMuted": {
    "_rgb": [
      74,
      70,
      60
    ],
    "_population": 127,
    "_hsl": [
      0.11904761904761907,
      0.10447761194029856,
      0.2627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Sally4Ever-S1.js